import { DynamicFieldInstruction } from '@common/instructions/frontend-shared';
export class ItemTaskSchedulerInstruction extends DynamicFieldInstruction {
  getDefaults() {
    return {};
  }
  constructor(config) {
    super();
    this.isInput = false;
    this.useFieldWrapper = false;
    this.attributeMap = {};
    this.inputMap = {
      formService: 'formService'
    };
    this.setConfig(config);
  }
  load() {
    return import(/* webpackChunkName: "item-task-scheduler" */
    /* webpackMode: "lazy" */
    '../ui/item-task-scheduler.component').then(m => m.ItemTaskSchedulerComponent);
  }
  addDynamicInputValues(map, sourceMapName, formGroup, formService) {
    if (!formService) throw new Error('ItemTaskSchedulerInstruction can only be used with a FormService-based form!');
    map['formService'] = formService;
    return map;
  }
}